import { searchAgreements } from "../../../../actions/CarrierAgreementMgmt/Agreements";
import { useMutation } from "react-query";

const useSearchAgreements = () => {
  return useMutation(searchAgreements);
};

export default useSearchAgreements;
